(function() {
  'use strict';

  class FaqV2Section extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._handleClick.bind(this);
      this._onResize = this._syncOpenHeights.bind(this);
      this._onBlockSelect = this._handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
      window.addEventListener('resize', this._onResize);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      this._initializeState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    _initializeState() {
      const items = this._getItems();
      items.forEach((item) => {
        const button = item.querySelector('[data-faq-v2-question]');
        const answer = item.querySelector('[data-faq-v2-answer]');
        if (!button || !answer) return;

        button.setAttribute('aria-expanded', 'false');
        answer.setAttribute('aria-hidden', 'true');
        answer.style.maxHeight = '0px';
        item.classList.remove('is-open');
      });

      if (this.dataset.openFirst !== 'true') return;

      const firstItem = items[0];
      if (firstItem) {
        this._openItem(firstItem, false);
      }
    }

    _handleClick(event) {
      const button = event.target.closest('[data-faq-v2-question]');
      if (!button || !this.contains(button)) return;

      const item = button.closest('[data-faq-v2-item]');
      if (!item) return;

      if (item.classList.contains('is-open')) {
        this._closeItem(item);
        return;
      }

      if (this.dataset.allowMultipleOpen !== 'true') {
        this._getItems().forEach((otherItem) => {
          if (otherItem !== item) {
            this._closeItem(otherItem);
          }
        });
      }

      this._openItem(item, true);
    }

    _handleBlockSelect(event) {
      const item = event.target.closest('[data-faq-v2-item]');
      if (!item || !this.contains(item)) return;

      if (this.dataset.allowMultipleOpen !== 'true') {
        this._getItems().forEach((otherItem) => {
          if (otherItem !== item) {
            this._closeItem(otherItem);
          }
        });
      }

      this._openItem(item, false);
      item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    _openItem(item, animate) {
      const button = item.querySelector('[data-faq-v2-question]');
      const answer = item.querySelector('[data-faq-v2-answer]');
      if (!button || !answer) return;

      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');

      if (!animate) {
        answer.style.maxHeight = 'none';
        const height = answer.scrollHeight;
        answer.style.maxHeight = `${height}px`;
        return;
      }

      answer.style.maxHeight = `${answer.scrollHeight}px`;
    }

    _closeItem(item) {
      const button = item.querySelector('[data-faq-v2-question]');
      const answer = item.querySelector('[data-faq-v2-answer]');
      if (!button || !answer) return;

      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
      answer.style.maxHeight = '0px';
    }

    _syncOpenHeights() {
      this._getItems().forEach((item) => {
        if (!item.classList.contains('is-open')) return;

        const answer = item.querySelector('[data-faq-v2-answer]');
        if (!answer) return;

        answer.style.maxHeight = `${answer.scrollHeight}px`;
      });
    }

    _getItems() {
      return Array.from(this.querySelectorAll('[data-faq-v2-item]'));
    }
  }

  if (!customElements.get('faq-v2-section')) {
    customElements.define('faq-v2-section', FaqV2Section);
  }
})();
